// extracted by mini-css-extract-plugin
export default {"container":"AdminVbmBarcodeScan_container__UJH2-"};